import React, { useState, useEffect } from 'react';
import ArtMovementPopup from './ArtMovementPopup';

const ClickableArtMovement = ({ artMovement, className = "", onPopupStateChange }) => {
  const [isPopupOpen, setIsPopupOpen] = useState(false);

  useEffect(() => {
    if (onPopupStateChange) {
      onPopupStateChange(isPopupOpen);
    }
  }, [isPopupOpen, onPopupStateChange]);

  const handleClick = () => {
    setIsPopupOpen(true);
  };

  const handleClosePopup = () => {
    setIsPopupOpen(false);
  };

  if (!artMovement) return null;

  return (
    <>
      <div className={`flex items-center gap-2 ${className}`}>
        <span className="text-amber-600 font-medium">{artMovement}</span>
        <button
          onClick={handleClick}
          className="text-amber-500 hover:text-amber-700 underline text-sm font-medium transition-colors duration-200"
          title={`Learn more about ${artMovement}`}
        >
          Click here
        </button>
      </div>

      <ArtMovementPopup
        artMovement={artMovement}
        isOpen={isPopupOpen}
        onClose={handleClosePopup}
      />
    </>
  );
};

export default ClickableArtMovement;






